<div class="container mb-2">
  <div class="row">
    <div class="col-12">
      <h1 class="page-title">{{ "REPORT_CHANGE" | globalTranslate }}</h1>
    </div>
  </div>

  <div class="row">
    <div class="card pb-2 px-0" style="width: 100%">
      <div class="card-body">
        @if (response) {
        <div class="d-none d-lg-block">
          <div class="row">
            <table class="table">
              <thead>
                <tr>
                  <th>{{ "Case" | globalTranslate }}</th>
                  <th>{{ "Action" | globalTranslate }}</th>
                </tr>
              </thead>
              <tbody>
                @for (item of this.caseDetails; track item) {
                <tr>
                  <td>{{ item.caseNum }}</td>
                  <td>
                    @if (item.openRenewalSW === 'N' && !item.isReportSsiEligble
                    && !item.isDcsEligible && item.hoHID === this.indivId) {
                    <button
                      class="btn btn-block btn-rcsecondary"
                      (click)="onReportChange(item.caseNum, 'RC')"
                    >
                      {{ "REPORT_CHANGE" | globalTranslate }}
                    </button>
                    } @if (item.openRenewalSW === 'Y') {
                    <p>{{ "REPORT_CHANGE_STATIC1" | globalTranslate }}</p>
                    } @if ((item.openRenewalSW === 'N' || item.openRenewalSW ===
                    null) && item.isReportSsiEligble) {
                    <p>{{ "REPORT_SSI_ELIGBLE" | globalTranslate }}</p>
                    } @if ((item.openRenewalSW === 'N' || item.openRenewalSW ===
                    null) && item.isDcsEligible) {
                    <p>
                      {{ "REPORT_DCS_ELIGIBLE" | globalTranslate }}<br /><br />
                      {{ "REPORT_DCS_ELIGIBLE_1" | globalTranslate }}
                    </p>
                    } @if (item.hoHID !== this.indivId) {
                    <p>{{ "REPORT_CHANGE_STATIC2" | globalTranslate }}</p>
                    }
                  </td>
                </tr>
                }
              </tbody>
            </table>
          </div>
        </div>
        } @if (response) {
        <div>
          <div class="nh-table-mobile d-lg-none">
            @if (caseSummary.length) { @for (item of caseDetails; track item) {
            <div>
              @if (item?.openRenewalSW === 'N') {
              <div class="table-row mb-3 pb-3">
                @if (item.openRenewalSW) {
                <div class="mobile-table-header">
                  {{ "Case" | globalTranslate }}
                </div>
                }
                <hr />
                @if (item.openRenewalSW) {
                <div class="mobile-table-data">{{ item.caseNum }}</div>
                }
                <br />
                @if (item.openRenewalSW) {
                <div class="mobile-table-header">
                  {{ "Action" | globalTranslate }}
                </div>
                }
              </div>
              }
              <div class="mobile-table-data">
                @if (item.openRenewalSW === 'N' && !item.isReportSsiEligble &&
                !item.isDcsEligible && item.hoHID === this.indivId) {
                <button
                  class="w-100 btn btn-block btn-rcsecondary"
                  (click)="onReportChange(item.caseNum, 'RC')"
                >
                  {{ "REPORT_CHANGE" | globalTranslate }}
                </button>
                } @if (item.openRenewalSW === 'Y') {
                <p>{{ "REPORT_CHANGE_STATIC1" | globalTranslate }}</p>
                } @if (item.openRenewalSW === 'N' && item.isReportSsiEligble) {
                <p>{{ "REPORT_SSI_ELIGBLE" | globalTranslate }}</p>
                } @if (item.openRenewalSW === 'N' && item.isDcsEligible) {
                <p>
                  {{ "REPORT_DCS_ELIGIBLE" | globalTranslate }}<br /><br />
                  {{ "REPORT_DCS_ELIGIBLE_1" | globalTranslate }}
                </p>
                } @if (item.hoHID !== this.indivId) {
                <p>{{ "REPORT_CHANGE_STATIC2" | globalTranslate }}</p>
                }
              </div>
              <br />
              <hr />
            </div>
            } } @if (!caseSummary.length) {
            <p class="mb-5">{{ "NO_DATA_TO_DISPLAY" | globalTranslate }}</p>
            }
          </div>
        </div>
        }
      </div>
    </div>
  </div>
</div>